import { useCallback } from 'react';

import { NotificationType } from '@sg/graphql-schema';

import { useOrderStatusNotificationPreferences } from '../../../../hooks/useOrderStatusNotificationPreferences';
import { type GetNotificationTypeResult, type Params } from './useNotificationType.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useNotificationType = () => {
  const { isPushSubscribed, isFeatureEnabled: isNotificationPreferencesEnabled } =
    useOrderStatusNotificationPreferences({
      requestPolicy: 'cache-first',
    });

  return useCallback(
    (params: Params): GetNotificationTypeResult => {
      if (!params.canTrackOrderStatus) {
        return {
          reason: 'Order is not trackable.',
        };
      }

      if (!isNotificationPreferencesEnabled) {
        return {
          notificationType: NotificationType.Push,
          reason: 'Notification Preferences FF is disabled.',
        };
      }

      if (!isPushSubscribed) {
        return {
          reason: 'Customer disabled order status notifications.',
        };
      }

      return {
        notificationType: NotificationType.Push,
      };
    },
    [isPushSubscribed, isNotificationPreferencesEnabled],
  );
};
